export default {
      id: "sensors-usage",
      viewBox: "0 0 26 19",
      url: __webpack_public_path__ + "img/icons.svg#sensors",
      toString: function () {
        return this.url;
      }
    }